import React, { useContext, useCallback } from 'react';

// DEPENDENCIES
import { useFormikContext } from 'formik';

// GLOBAL VARIABLES
import { RETAIL_WHOLESALE } from 'codes';
import { SALES_FILE_TYPE_IDS } from 'globals.js';

// HELPERS/FUNCTIONS
import { RecordContext } from 'helpers/getRecordData';

// GLOBAL COMPONENTS
import Form from 'core/form/Form';

// LOCAL COMPONENTS
import Card from '../parts/Card';
import Attachment from 'routers/interface/tools/attachment/Attachment';

// MAIN COMPONENT
const InvoiceSA2Form = () => {
  const { refetchRecord } = useContext(RecordContext);

  const { values: { sale_type_category_code, inventory } = {} } = useFormikContext() || {};
  const { new_used } = inventory || {};

  const isRetail = sale_type_category_code === RETAIL_WHOLESALE.retail.category_code;

  const documentType = {
    0: {
      RETAIL: SALES_FILE_TYPE_IDS.EDP_RETAIL_USED,
      WHOLESALE: SALES_FILE_TYPE_IDS.EDP_WHOLESALE_USED
    },
    1: {
      RETAIL: SALES_FILE_TYPE_IDS.EDP_RETAIL_NEW,
      WHOLESALE: SALES_FILE_TYPE_IDS.EDP_WHOLESALE_NEW
    }
  };

  const title = isRetail ? 'Executed Deal Package (SA2)' : "Auction Invoice / WS Buyer's Order (SA2)";

  const handleSuccess = useCallback(() => {
    refetchRecord();
  }, [refetchRecord]);

  return (
    <Form.Body>
      <Attachment.Upload
        label={title}
        name="documentAttachment.edp"
        documentType={documentType?.[new_used]?.[sale_type_category_code]}
        uploadType="sales"
        onComplete={handleSuccess}
        downloadRecent
      />
    </Form.Body>
  );
};

// EXPORT
export default function InvoiceSA2({ number, ...props }) {
  const { record: initialValues = {} } = useContext(RecordContext) || {};

  const isRetail = initialValues?.sale_type_category_code === RETAIL_WHOLESALE.retail.category_code;

  return (
    <Card
      number={number}
      title={isRetail ? 'Executed Deal Package (SA2)' : "Auction Invoice / WS Buyer's Order (SA2)"}
      color="yellow"
      body={
        <Form initialValues={initialValues || {}}>
          <InvoiceSA2Form {...props} />
        </Form>
      }
    />
  );
}
